import { useTLang } from 'intl/intl';

export function useTurnOffCustomizationLang() {
  return {
    title: useTLang({ id: 'menuPage.turnOff.item.title.customization' }),
    action: {
      primaryBtn: useTLang({ id: 'menuPage.turnOff.item.action.primaryBtn' }),
    },
  };
}
